import o from "./ghl-ui.es1506.js";
import a from "./ghl-ui.es1466.js";
function u(t) {
  a(1, arguments);
  var r = o(t), e = r.getMonth();
  return e;
}
export {
  u as default
};
